import {
    trigger,
    style,
    animate,
    transition
} from '@angular/animations';

/**
 * Contains all easing cubic beziers according to the material design spec
 * @see https://material.io/guidelines/motion/duration-easing.html#duration-easing-natural-easing-curves
 */
export const easing = {
    /**
     * The standard curve (also referred to as “ease in out”) is the most common easing curve.
     * Elements quickly accelerate and slowly decelerate between on-screen locations.
     * It applies to growing and shrinking material, among other property changes.
     */
    standard: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    /**
     * Using the deceleration curve (also referred to as “ease out”) elements enter the screen at full velocity and slowly decelerate to a resting point.
     */
    enter: 'cubic-bezier(0.0, 0.0, 0.2, 1)',

    /** Using the acceleration curve (also referred to as “ease in”) elements leave the screen at full velocity. They do not decelerate when off-screen */
    leave: 'cubic-bezier(0.4, 0.0, 1, 1)'
};

export const fadeInOut = [
    trigger('fadeInOut', [
        transition(':enter', [
            style({
                opacity: 0
            }),
            animate(`250ms ${easing.enter}`, style({
                opacity: 1
            }))
        ]),
        transition(':leave', [
            style({
                opacity: 1
            }),
            animate(`250ms ${easing.leave}`, style({
                opacity: 0
            }))
        ])
    ])
]



// WEBPACK FOOTER //
// ./src/utils/animations.ts